import { useNavigate } from 'react-router-dom'

// Custom components
import PageWrapper from 'components/PageWrapper'
import CardButton from 'components/CardButtons'

import clip from 'assets/images/emojis/clip.png'
import lightbulb from 'assets/images/emojis/light-bulb.png'
import mailbox from 'assets/images/emojis/mailbox.png'
import scale from 'assets/images/emojis/scale.png'
import { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'

const BUTTONS = [
  {
    icon: lightbulb,
    title: 'Preguntas frecuentes',
    description: 'Respuestas a las preguntas que seguramente tenés.',
    event: 'bille_centro_de_ayuda_boton_faq',
    page: 'preguntas-frecuentes'
  },
  {
    icon: clip,
    title: 'Legales',
    description: 'Lo que tenés que saber al usar nuestros servicios.',
    event: 'bille_centro_de_ayuda_boton_legales',
    page: 'legales'
  },
  {
    icon: scale,
    title: 'Información al consumidor',
    description: 'Tus derechos y obligaciones como consumidor.',
    event: 'bille_centro_de_ayuda_boton_informacion',
    page: 'informacion-al-consumidor'
  },
  {
    icon: mailbox,
    title: 'Contactanos',
    description: 'Para responder a tus consultas o simplemente conocerte.',
    event: 'bille_centro_de_ayuda_boton_contacto',
    page: 'contactanos'
  }
]

const HelpCenter = () => {
  const navigate = useNavigate()

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_centro_de_ayuda' })
  }, [])

  return (
    <PageWrapper
      viewSelected='/centro-de-ayuda'
      className='!px-0 md:px-4'
      title='Centro de ayuda'
      noTabBar
    >
      <section className='px-4 mt-6 text-black md:flex md:max-w-564 md:flex-col mb-20 md:mb-5 mx-auto'>
        <div className='space-y-4'>
          {BUTTONS.map((b) => (
            <CardButton
              key={b.page}
              icon={b.icon}
              title={b.title}
              description={b.description}
              onClick={() => {
                trackEvent({ eventName: b.event })
                navigate(b.page)
              }}
            />
          ))}
        </div>
      </section>
    </PageWrapper>
  )
}

export default HelpCenter
